var map = {
	"./上海": "QXfD",
	"./上海.json": "QXfD",
	"./云南": "oX9m",
	"./云南.json": "oX9m",
	"./内蒙古": "cycU",
	"./内蒙古.json": "cycU",
	"./北京": "o19O",
	"./北京.json": "o19O",
	"./吉林": "N7DB",
	"./吉林.json": "N7DB",
	"./四川": "anHm",
	"./四川.json": "anHm",
	"./天津": "n4HS",
	"./天津.json": "n4HS",
	"./宁夏": "9yoy",
	"./宁夏.json": "9yoy",
	"./安徽": "fmZe",
	"./安徽.json": "fmZe",
	"./山东": "rLvj",
	"./山东.json": "rLvj",
	"./山西": "R4Hm",
	"./山西.json": "R4Hm",
	"./广东": "ikxO",
	"./广东.json": "ikxO",
	"./广西": "VmI3",
	"./广西.json": "VmI3",
	"./新疆": "QsST",
	"./新疆.json": "QsST",
	"./江苏": "nSJT",
	"./江苏.json": "nSJT",
	"./江西": "JyrF",
	"./江西.json": "JyrF",
	"./河北": "t3WP",
	"./河北.json": "t3WP",
	"./河南": "zhd9",
	"./河南.json": "zhd9",
	"./浙江": "wZw/",
	"./浙江.json": "wZw/",
	"./海南": "VY1T",
	"./海南.json": "VY1T",
	"./湖北": "WPO8",
	"./湖北.json": "WPO8",
	"./湖南": "m7AY",
	"./湖南.json": "m7AY",
	"./澳门": "zQ4E",
	"./澳门.json": "zQ4E",
	"./甘肃": "kul4",
	"./甘肃.json": "kul4",
	"./福建": "2nEM",
	"./福建.json": "2nEM",
	"./西藏": "7Wko",
	"./西藏.json": "7Wko",
	"./贵州": "jtQ0",
	"./贵州.json": "jtQ0",
	"./辽宁": "+FYb",
	"./辽宁.json": "+FYb",
	"./重庆": "1yk6",
	"./重庆.json": "1yk6",
	"./陕西": "DA5J",
	"./陕西.json": "DA5J",
	"./青海": "lfq3",
	"./青海.json": "lfq3",
	"./香港": "o3cr",
	"./香港.json": "o3cr",
	"./黑龙江": "S49n",
	"./黑龙江.json": "S49n"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nrMp";


//////////////////
// WEBPACK FOOTER
// ./src/utils/省份数据/json(省份) ^\.\/.*$
// module id = nrMp
// module chunks = 1